import { useNavigate } from 'react-router';
import { Card, Stack } from '@mui/material';

import { Strings } from '@app/constants';
import { DataNotFound, Scrollbar } from '@app/components';
import { InfoStatusCard } from '@app/components/card/info-status-card';
import { StyledTitle } from '@app/modules/dashboard/style';
import { ILeaveDetails } from '@app/modules/add-leave-employee';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { calculateTotalLeaves } from '@app/configs';
import { IManagerDashboard } from '../type';

interface Props {
  data: IManagerDashboard;
}
const MangerRequestedApprovedLeaves = ({ data }: Props) => {
  const navigate = useNavigate();

  return (
    <Stack flexDirection={{ sm: 'column', md: 'row' }} mb={3}>
      <Card
        sx={{
          width: { sm: '97%', md: '45%' },
          maxHeight: { xs: '200px' },
          height: { md: '200px' },
          margin: '0 2% 0 2%',
          marginTop: { xs: '2%', sm: '2%', md: '0%' },
          borderRadius: '5px',
        }}
      >
        <StyledTitle>{Strings.dashboard.requestedLeaves}</StyledTitle>
        <Scrollbar sx={{ height: { md: 160 }, maxHeight: { xs: 160 } }}>
          {data?.requestedLeaves?.leave && data?.requestedLeaves?.leave?.length > 0 ? (
            data?.requestedLeaves?.leave?.map((option: ILeaveDetails) => {
              const openDetailsPage = () => {
                navigate(PATH_DASHBOARD.leaveDetail, { state: { id: option?.id } });
              };
              return (
                <InfoStatusCard
                  key={option.id}
                  titleName={`${option.user.firstName} ${option.user.lastName}`}
                  subTitleHead={`${option.from} to`}
                  subTitleValue={option.to}
                  actionTime={`${option?.periods?.length} days`}
                  onClick={openDetailsPage}
                />
              );
            })
          ) : (
            <DataNotFound height={140} />
          )}
        </Scrollbar>
      </Card>
      <Card
        sx={{
          width: { sm: '97%', md: '55%' },
          maxHeight: { xs: '200px' },
          height: { md: '200px' },
          margin: { xs: '0 2% 0 2%', sm: '0 2% 0 2%', md: '0 2% 0 0%' },
          marginTop: { xs: '2%', sm: '2%', md: '0%' },
          borderRadius: '5px',
        }}
      >
        <StyledTitle>{Strings.dashboard.approvedLeaves}</StyledTitle>
        <Scrollbar sx={{ height: { md: 160 }, maxHeight: { xs: 160 } }}>
          {data?.approvedLeaves && data.approvedLeaves.length > 0 ? (
            data?.approvedLeaves?.map((option: ILeaveDetails) => {
              const openDetailsPage = () => {
                navigate(PATH_DASHBOARD.leaveDetail, { state: { id: option?.id } });
              };
              const totalLeaveCount: number = calculateTotalLeaves(option.periods);
              return (
                <InfoStatusCard
                  key={option.id}
                  titleName={`${option.user.firstName} ${option.user.lastName}`}
                  subTitleHead={`${option.from} to`}
                  subTitleValue={`${option.to} (${totalLeaveCount} days)`}
                  actionHead={`${Strings.dashboard.approvedBy} :`}
                  actionValue={`${option.approvedUser?.firstName ?? ''} ${
                    option.approvedUser?.lastName ?? ''
                  }`}
                  onClick={openDetailsPage}
                />
              );
            })
          ) : (
            <DataNotFound height={140} />
          )}
        </Scrollbar>
      </Card>
    </Stack>
  );
};

export { MangerRequestedApprovedLeaves };
